import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_INFOPANEL';

const en = {
    info_icon_tooltip: 'View summarized details in panel',
    info_zoom_tooltip: 'Open in new window',
    collapse_btn_tooltip: 'Close details',
    expand_btn_tooltip: 'Open details',
    feature_popover_title: 'More details',
    feature_popover_content: 'Choose the ‘i’ button to see more relevant details.',
    feature_popover_ignore_btn: 'OK, got it',
    feature_popover_approve_btn: 'Show me',
    edit_btn_tooltip: 'Edit',
    edit_fields_title: 'Choose Fields to View',
    available_fields_title: 'Available Fields',
    search_placeholder: 'Search...',
    selected_title: 'Selected Fields',
    btn_save: 'Save',
    btn_cancel: 'Cancel',
    btn_reset: 'Restore defaults',
    no_result_msg: 'We did not find results that match your search.',
    max_amount_msg:
        'You have reached the maximum amount of fields. Delete a selected field to add an available field.',
    empty_selected_msg: 'Leave at least one selected field.',
    saved_success_msg: 'We successfully saved your changes',
    exit_msg: 'Exit without saving your changes?',
    exit_msg_yes: 'Yes',
    exit_msg_no: 'No',
    show_more_btn: 'Show More',
    no_details_msg: 'No details to show here.\n Update details in the form.',
    results_info: 'Showing X results. See more here',
    help_label: 'Help',
    ok_label: 'OK',
    help_content:
        'Here you can view additional details related to the field you are currently in. Instead of drilling down to another form to see more details, the information is available here. Want to personalize which details to see? Select the pencil icon to edit and choose your preferred fields. \n' +
        'Want to drill down to the form? Select the icon next to the form name. \n Find more information in the User Interface Guide. ',
    help_edit_content:
        'Here you can choose which fields will show up in the side panel. \n On the left are the available fields you can choose from. \n Add preferred fields using the plus icon (+), and they will move to the right side. \n To clear fields, use the minus icon (-). \n Find more information in the User Interface Guide. ',
    no_access_title: 'There seem to be no available details to show.',
    no_access_msg:
        'Details are shown here according to your routine work \n processes and system permissions.',
    recommendation_title: 'Recommendations for you',
    recommendation_suggestion:
        'We notice that you use the X form frequently. \n We can add it to your More Details panel, so whenever you click the i icon, the most relevant information appears.',
    snooze_btn: 'Later',
    reject_btn: `Don't show again`,
    recommendation_content:
        'To add more information to the panel, we need to remove a section. \n Which do you want to remove?',
    settings_tooltip: 'Here you can choose the information that appears in the panel.',
    selected_forms: 'Selected Forms',
    available_forms: 'Available Forms',
    max_forms_tooltip:
        'You have reached the maximum amount of forms. Remove a selected form to add an available form.',
    min_forms_tooltip: 'Select a minimum of one form.',
    postpone_label: 'Maybe later'
};

const he = {
    info_icon_tooltip: 'לחצו כדי לצפות בתקציר הפרטים בחלונית',
    info_zoom_tooltip: 'פתיחה במסך מלא',
    collapse_btn_tooltip: 'לסגור את הפרטים',
    expand_btn_tooltip: 'לצפות בפרטים',
    feature_popover_title: 'i חדש!',
    feature_popover_content: 'פרטים נוספים רלוונטיים מחכים לך בלחיצה על האייקון i.',
    feature_popover_ignore_btn: 'הבנתי',
    feature_popover_approve_btn: 'אני רוצה לראות',
    edit_btn_tooltip: 'עריכה',
    edit_fields_title: 'בחירת שדות להצגה',
    available_fields_title: 'שדות אפשריים',
    search_placeholder: 'חיפוש...',
    selected_title: 'שדות להצגה',
    btn_save: 'שמירה',
    btn_cancel: 'ביטול',
    btn_reset: 'שחזור ברירת מחדל',
    no_result_msg: 'לא מצאנו שדה שמתאים לחיפוש שלך.',
    max_amount_msg: 'הגעת למספר השדות המקסימלי.',
    empty_selected_msg: 'יש להציג לפחות שדה אחד.',
    saved_success_msg: 'שמרנו את השינויים בהצלחה.',
    exit_msg: 'האם לצאת בלי לשמור את השינויים?',
    exit_msg_yes: 'כן',
    exit_msg_no: 'לא',
    show_more_btn: 'לראות עוד',
    no_details_msg: 'אין כרגע פרטים להצגה.\n אפשר לעדכן את הפרטים במסך עצמו.',
    results_info: 'מציגים X תוצאות. שאר התוצאות כאן.',
    help_label: 'עזרה',
    ok_label: 'אישור',
    help_content:
        'כאן מופיעים פרטים נוספים רלוונטים לשדה שבו אתם נמצאים כרגע. במקום לצלול למסכים אחרים במערכת, המידע שאתם צריכים מופיע כאן במרוכז. \n רוצים לראות פרטים אחרים? לחצו על העיפרון לעריכה, ובחרו את השדות הרלוונטיים לכם. \n רוצים לצלול למסכים עצמם? לחצו על האייקון לצד שם המסך. עוד עזרה במדריך לממשק משתמש.',
    help_edit_content:
        'כאן בוחרים אילו פרטים יופיעו בחלונית ממסך זה. בצד ימין מופיעים השדות שאפשר להציג. \n בחרו את השדות הרלוונטיים לכם בעזרת הפלוס (+) והם יעברו לצד שמאל. \n בצד שמאל מופיעים השדות שמוצגים בחלונית. \n הורידו את השדות שאינם רלוונטיים לכם על ידי המינוס (-).\n עוד עזרה במדריך לממשק משתמש. ',
    no_access_title: 'נראה שכרגע אין פרטים זמינים להצגה.',
    no_access_msg: 'נתונים מוצגים כאן בהתאם לתהליכי העבודה השגורים בחברתך ולהרשאות מערכת.',
    recommendation_title: 'המלצות במיוחד בשבילך',
    recommendation_suggestion:
        'שמנו לב שהמסך X שימושי במיוחד עבורך. \n נוכל להוסיף אותו לחלונית הפרטים הנוספים, כך שבכל לחיצה על האייקון i יופיע המידע הרלוונטי לך כרגע.',
    snooze_btn: 'אחר כך',
    reject_btn: 'לא להציע לי שוב',
    recommendation_content:
        'כדי להוסיף עוד מידע לחלונית נצטרך להוריד כרטיסייה אחת. \n איזו אפשר להוריד?',
    settings_tooltip: 'כאן אפשר לבחור עצמאית את המידע שמופיע בפאנל.',
    selected_forms: 'מסכים להצגה',
    available_forms: 'מסכים אפשריים',
    max_forms_tooltip: 'הגעת למספר המסכים המקסימלי. לפני שמוסיפים עוד מסך צריך להוריד אחד.',
    min_forms_tooltip: 'יש להשאיר מסך אחד לפחות.',
    postpone_label: 'אולי אחר כך'
};

const fallbacks = {en, he};

export const mapping = {
    2: 'info_icon_tooltip',
    3: 'info_zoom_tooltip',
    4: 'collapse_btn_tooltip',
    5: 'expand_btn_tooltip',
    7: 'feature_popover_title',
    8: 'feature_popover_content',
    9: 'feature_popover_ignore_btn',
    10: 'feature_popover_approve_btn',
    11: 'edit_btn_tooltip',
    12: 'edit_fields_title',
    13: 'available_fields_title',
    14: 'search_placeholder',
    15: 'selected_title',
    16: 'btn_save',
    17: 'btn_cancel',
    18: 'btn_reset',
    19: 'no_result_msg',
    20: 'max_amount_msg',
    21: 'empty_selected_msg',
    22: 'saved_success_msg',
    23: 'exit_msg',
    24: 'exit_msg_yes',
    25: 'exit_msg_no',
    26: 'show_more_btn',
    27: 'no_details_msg',
    28: 'results_info',
    29: 'help_label',
    30: 'ok_label',
    31: 'help_content',
    32: 'help_edit_content',
    33: 'no_access_title',
    34: 'no_access_msg',
    35: 'recommendation_title',
    36: 'recommendation_suggestion',
    37: 'snooze_btn',
    38: 'reject_btn',
    39: 'recommendation_content',
    40: 'settings_tooltip',
    41: 'selected_forms',
    42: 'available_forms',
    43: 'max_forms_tooltip',
    44: 'min_forms_tooltip',
    45: 'postpone_label'
};

export const getServerTexts = () => getTexts(entity, mapping);

initTexts(entity, fallbacks);

export default texts[entity] as typeof en;
